import { Div } from "../../../../../base/components/native/div"
import services from "../../../../../services"
import { TFAQ } from "../../../../../types/faq"
import { submitButton } from "../../shared/submit-button"
import { Tab } from "../tab"
import { FAQEditor } from "./faq-editor"
import { FAQsList } from "./faqs-list"
import { contentsSyle, editorStyle, submitStyle, viewStyle } from "./faqs.style"

export const FAQsTab = () => {
    let _faq: TFAQ = {
        key: new Date().getTime().toString(),
        q: '',
        a: ''
    }
    const base = Tab('editor')

    const contents = Div()
    contents.cssClass(contentsSyle)
    base.append(contents)

    const view = Div()
    view.cssClass(viewStyle)
    contents.append(view)

    const Q = FAQEditor()
    Q.cssClass(editorStyle)
    Q.on('change', (contents: string) => {
        _faq.q = contents
        list.update(_faq)
    })

    view.append(Q)

    const A = FAQEditor()
    A.cssClass(editorStyle)
    view.append(A)
    A.on('change', (contents: string) => {
        _faq.a = contents
        list.update(_faq)
    })

    const submit = submitButton('به روز رسانی')
    submit.enable()
    submit.cssClass(submitStyle)
    view.append(submit)

    const list = FAQsList()
    contents.append(list)
    list.on('select', (faq: TFAQ) => {
        _faq = faq
        Q.setContents(faq.q)
        A.setContents(faq.a)
    })

    submit.el.addEventListener('click', async () => {
        submit.text('در حال ارسال...')
        submit.disable()
        const payload = {
            items: list.getValue().items
        }
        console.log(payload, 'payload');

        await services.faqs.post(payload)
        submit.text(' به روز رسانی')
        submit.enable()
    })

    return base
}